import template from './macquarieAssetFinanceSendDocuments.template.html';

export default {
  template,
  bindings: {
    documents: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdMedia, lodgementService, uiService, LODGEMENT) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.limit = 8;
      ctrl.showMoreDocuments = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.availablePurposeOptions = _.sortBy(
          LODGEMENT.MACQUARIE_ASSET_FINANCE.PURPOSE_OPTIONS,
          'name'
        );
        ctrl.availableDocumentClassOptions = _.sortBy(
          LODGEMENT.MACQUARIE_ASSET_FINANCE.DOCUMENT_CLASS_OPTIONS,
          'name'
        );
        ctrl.documents = ctrl.documents || [];
        ctrl.selectedDocuments = [];
        ctrl.prepareDocuments();
        ctrl.isReady = true;
      };

      ctrl.prepareDocuments = () => {
        _.forEach(ctrl.documents, (d) => {
          const doc = d;
          doc.isSelected = false;
          return doc;
        });
      };

      ctrl.select = ({ document }) => {
        const file = document;
        file.isSelected = !file.isSelected;
        const idx = _.findIndex(ctrl.selectedDocuments, (d) => d?.file?.id === file?.id);
        if (idx === -1) {
          ctrl.selectedDocuments.push({
            file,
            documentClass: '',
            comments: '',
            description: '',
            purpose: ''
          });
        } else {
          ctrl.selectedDocuments.splice(idx, 1);
        }
      };

      ctrl.getSelectedDocument = ({ document }) =>
        _.find(ctrl.selectedDocuments, (d) => d?.file?.id === document?.id);

      ctrl.toggleShowMore = () => {
        ctrl.showMoreDocuments = !ctrl.showMoreDocuments;
        ctrl.limit = ctrl.showMoreDocuments ? undefined : 8;
      };

      ctrl.canSend = () =>
        _.every(
          ctrl.selectedDocuments || [],
          (d) => d?.documentClass !== '' && d?.purpose !== ''
        );

      ctrl.sendDocuments = () => {
        if (ctrl.selectedDocuments?.length || ctrl.canSend()) {
          const selectedDocuments = JSON.parse(JSON.stringify(ctrl.selectedDocuments));
          ctrl.prepareDocuments();
          ctrl.selectedDocuments = [];
          ctrl.onFinished({ selectedDocuments });
        }
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
